import {
    NEW_PLANO_CONTA_CADASTRO_SUCCESS,
    CANCEL_PLANO_CONTA_CADASTRO_RAPIDO,
    CANCEL_PLANO_CONTA_CADASTRO_RAPIDO_SUCCESS,
    TABLE_PLANO_CONTA_CADASTRO_PENDING,
    TABLE_PLANO_CONTA_CADASTRO_SUCCESS,
    TABLE_PLANO_CONTA_CADASTRO_FAILURE,
    LIST_PLANO_CONTA_CADASTRO_PENDING,
    LIST_PLANO_CONTA_CADASTRO_SUCCESS,
    LIST_PLANO_CONTA_CADASTRO_FAILURE,
    FIND_PLANO_CONTA_CADASTRO_PENDING,
    FIND_PLANO_CONTA_CADASTRO_SUCCESS,
    FIND_PLANO_CONTA_CADASTRO_FAILURE,
    DELETE_PLANO_CONTA_CADASTRO_PENDING,
    DELETE_PLANO_CONTA_CADASTRO_SUCCESS,
    DELETE_PLANO_CONTA_CADASTRO_FAILURE,
    CREATE_PLANO_CONTA_CADASTRO_PENDING,
    CREATE_PLANO_CONTA_CADASTRO_SUCCESS,
    CREATE_PLANO_CONTA_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function planoContaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_PLANO_CONTA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_PLANO_CONTA_CADASTRO_PENDING:
        case FIND_PLANO_CONTA_CADASTRO_PENDING:
        case DELETE_PLANO_CONTA_CADASTRO_PENDING:
        case CREATE_PLANO_CONTA_CADASTRO_PENDING:
        case TABLE_PLANO_CONTA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_PLANO_CONTA_CADASTRO_RAPIDO:
        case CANCEL_PLANO_CONTA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_PLANO_CONTA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_PLANO_CONTA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_PLANO_CONTA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_PLANO_CONTA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_PLANO_CONTA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_PLANO_CONTA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_PLANO_CONTA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_PLANO_CONTA_CADASTRO_SUCCESS:
        case CREATE_PLANO_CONTA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_PLANO_CONTA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { planoContaCadastroReducer };